import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

import Delete from "components/GenericViews/Delete"
import { reverse } from "utils/urls"

export default function AirlineDelete(props) {
  const { t } = useTranslation()

  return (
    <Delete
      modelName={t("Airline")}
      endpoint={`/airlines/${props.match.params.id}/`}
      successRoute={reverse("airlineList")}
      errorRoute={reverse("airlineDetail", { id: props.match.params.id })}
    />
  )
}

AirlineDelete.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
